<template>
  <div class="dlrGetWX">
    <div class="dlrGetWX-bg">
      <a href="javascript:void(0);" class="dlrGetWX-close" @click="handleClose">
        <em></em>
      </a>
      <div class="dlrGetWX-title">
        <h3>{{ titleInfo }}</h3>
      </div>
      <div class="dlrGetWX-form">
        <div class="dlrGetWX-form-input">
          <div class="dlrGetWX-form-icon">
            <em></em>
            <span>微信号</span>
          </div>
          <div
            class="dlrGetWX-form-text"
            v-stat:show="{
              action: 'dlr_vr_page_chat_buttom_show',
              extend: { channelId },
            }"
            v-stat:click="{
              action: 'dlr_vr_page_chat_buttom_click',
              extend: { channelId },
            }"
          >
            <input
              v-model="encryptedPhone"
              type="tel"
              maxlength="11"
              placeholder="填微信绑定的手机"
              @focus="showInputPhone"
              @blur="showEncryptedPhone"
            />
          </div>
        </div>
        <div v-show="orderUI.showSmsCode" class="dlrGetWX-form-input">
          <div class="dlrGetWX-form-icon">
            <em class="icon-shield_gray"></em>
            <span>验证码</span>
          </div>
          <div class="dlrGetWX-form-text">
            <input
              v-model="orderData.smsCode"
              maxlength="6"
              type="tel"
              placeholder="填短信验证码"
              name="phone"
              @focus="showInputPhone"
              @blur="showEncryptedPhone"
            />
          </div>
          <a v-if="orderUI.remainTimes" href="javascript:void(0);" class="dlrGetWX-form-link disabled">
            重新发送({{ orderUI.remainTimes }}s)
          </a>
          <a v-else href="javascript:void(0);" class="dlrGetWX-form-link" @click="order.sendSms"> 发送验证码 </a>
        </div>
        <div
          class="dlrGetWX-form-btn"
          @click="submitOrderForm"
          v-stat:show="{
            action: 'dlr_baojia_page_tongyiweixin_show',
            extend: { channelId, dealerId, seriesId },
          }"
          v-stat:click="{
            action: 'dlr_baojia_page_tongyiweixin_click',
            extend: { channelId, dealerId, seriesId },
          }"
        >
          <a href="javascript:void(0);">
            <span>同意</span>
          </a>
        </div>
        <div class="dlrGetWX-form-agreement" @click="toggleAgreementChecked">
          <i class="dlrGetWX-form-agreement-icon" :class="{ checked: agreementChecked }"></i>
          <span>点击提交即同意</span>
          <a href="javascript:void(0);" @click.stop="openProtocal"> {{ agreementInfo.agreementDesc }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import { defineComponent, ref, watch,toRefs } from 'vue-demi';
import { useDealerBusiOrder, usePhoneProtected } from '@auto/dealer-busi-order';
import utils from '../../utils/util';
import layerManager from '../../services/layer.manager';
import queryParams from '../../services/pageQuery.service';
import * as layerNames from '../../services/layerName';
// import Layer from '../Layer.vue';
import store from '../../store';
import orderApi from '../../apis/order.api';
import { DefaultAgreementInfo } from '@auto/dealer-order-agreement';
import { useAgreeMent } from '../../services/agreement.service';
import orderButtonProxy from '../../services/actionSync/order.button.proxy';
export default defineComponent({
  components: {
    // Layer,
  },
  props: {
    dealerId: {
      type: Number,
      required: true,
    },
    seriesId: {
      type: Number,
      required: true,
    },
    seriesName:{
      type: String,
      default:''
    },
    elementId: {
      type: String,
      default: '2|1211004|897|24487|205630|304763',
    },
    titleInfo:{
      type:String,
      default:''
    }
  },
  setup (props) {
    const {dealerId,seriesId} = toRefs(props)
    const disabled = ref(false);
    const visible = ref(true);
    const vrSalesInfo = store.state.sales.vrSalesInfo;
    const deviceId = utils.getCookie('app_deviceid') || '-1';
    const env = process.env.NODE_ENV !== 'production' ? 'test' : 'prod';
    const order = useDealerBusiOrder({
      deviceId: deviceId,
      time: 60,
      appId: 'dealer.vr',
      source: 'dealer.vr',
      env: env,
    });
    const loaded = ref(false);

    function handleClose () {
      layerManager.close(layerNames.USER_WE_CHAT_PHONE);
      layerManager.close(layerNames.TRANSPARENT_MASK);
      orderButtonProxy.closeWeChatPhoneOrder();
      visible.value = false;
    }
    order.orderData.dealerIds = [dealerId.value];
    order.orderData.seriesIds = [seriesId.value];

    const phoneInput = usePhoneProtected(order.orderData);
    const cityId = store.state.baseInfo.cityId;
    const agreement = useAgreeMent(
      env,
      '',
      order.orderData,
      cityId,
    );


    function submitOrderForm () {
      order.orderData.userName = order.orderData.userName || '带看C端';
      const validResult = order.valid();
      if (validResult) {
        layerManager.toast(
          { propsData: { message: validResult.message } },
          2000,
          );
        return;
      }
      if (order.orderUI.showSmsCode && !/\d{6,6}/.test(order.orderData.smsCode)) {
        layerManager.toast(
          { propsData: { message: '请填写正确的验证码！' } },
          2000,
          );
        return;
      }
      if (!utils.checkPhone(order.orderData.phone)) {
        layerManager.toast(
          { propsData: { message: '请填写正确的手机号！' } },
          2000,
          );
          return;
      }
      if (!agreement.agreementChecked.value) {
        layerManager.toast(
            { propsData: { message: agreement.tipText } },
            2000,
          );
        return;
      }
      if (disabled.value) {
        layerManager.toast( { propsData: { message: '提交中，请勿频繁提交！' } }, 2000);
        return;
      }
      disabled.value = true;
      orderApi.createWeChatPhoneOrder({
        channelId: vrSalesInfo.channelId || '1105520549519519744',
        siteId: 628,
        eid: props.elementId,
        cityId: cityId,
        phone: order.orderData.phone,
        referrer: encodeURIComponent(window.document.referrer),
        loadId: window.pageLoadId || '',
        pvAreaId: queryParams.pvAreaId,
        seriesId: order.orderData.seriesIds[0],
        seriesName: props.seriesName || '',
        currentUrl: encodeURIComponent(window.location.href),
        sessionId: utils.getCookie('sessionid') || '',
        deviceId: deviceId,
        activityId:'-1',
        smsCode: order.orderData.smsCode,
        guid: order.orderData.smsGuid,
        dealerIds: order.orderData.dealerIds.join(','),
        source: 'dealer.vr'
      })
      .then((res)=>{
        disabled.value = false;
        orderButtonProxy.weChatPhoneOrder(order.orderData.phone);
        order.savePhoneName();
        order.needSmsCode();
        handleClose();
        layerManager.toast({ propsData: { message: '提交成功！' } }, 1500);
      })
      .catch(ex=>{
        disabled.value = false;
        // orderButtonProxy.weChatPhoneOrder(order.orderData.phone);
        // handleClose();
        layerManager.toast({ propsData: { message: ex.message || '网络错误，请联系管理员！' } }, 1500);
      });
    }
    order.onError(({ name, error }) => {
      console.log('order-error', name, error);
      layerManager.toast({ propsData: { message: error.message } }, 2000);
    });
    const openProtocal = () =>
      layerManager.open(layerNames.PROTOCAL, {
        propsData: {
          title: '',
          src: DefaultAgreementInfo.agreementUrl,
        },
      });

    function imageCodeLayerConfirm (imgCode) {
      order.orderData.imageVCode = imgCode;
      order.sendSms().then((sended) => {
        order.orderData.imageVCode = '';
        order.orderData.smsCode = '';
        if (sended) {
          imageCodeLayerClose();
        }
      });
    }
    function imageCodeLayerClose () {
      order.orderUI.showImageVCode = false;
    }
    watch(
      () => order.orderUI.showImageVCode,
      () => {
        if (order.orderUI.showImageVCode) {
          layerManager.open(layerNames.USER_WE_CHAT_PHONE_IMG_CODE_LAYER, {
            propsData: {
              orderUI: order.orderUI,
              refreshImgCode: () => {
                order.refreshImgCode();
              },
              confirmImgCode: (imgCode) => {
                imageCodeLayerConfirm(imgCode);
              },
              closeImgCode: imageCodeLayerClose,
            },
          });
        }
      },
      { immediate: true },
    );

    const channelId = vrSalesInfo.channelId;
    return {
      order,
      channelId,
      disabled,
      ...order,
      openProtocal,
      ...phoneInput,
      submitOrderForm,
      handleClose,
      visible,
      loaded,
      agreementInfo:DefaultAgreementInfo,
      toggleAgreementChecked: agreement.toggleAgreementChecked,
      agreementChecked: agreement.agreementChecked,
    };
  },
});
</script>
<style lang="scss">
@import '@/assets/scss/modules/_VRGetWX.scss';
</style>
